// src/components/common/ToggleSwitch.js
const ToggleSwitch = ({ enabled, setEnabled, color = 'primary' }) => {
  return (
    <button
      type="button"
      className={`${
        enabled 
          ? color === 'secondary' 
            ? 'bg-secondary shadow-md shadow-purple-500/40' 
            : 'bg-primary shadow-md shadow-orange-500/40'
          : 'bg-gray-300 dark:bg-gray-600'
      } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-all duration-200 ease-in-out ${
        color === 'secondary' ? 'focus:ring-secondary' : 'focus:ring-primary'
      } focus:ring-offset-2 backdrop-blur-sm hover:shadow-lg`}
      role="switch"
      aria-checked={enabled}
      onClick={() => setEnabled(!enabled)}
    >
      {/* Glass overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/30 to-transparent opacity-70 dark:from-white/10 dark:opacity-50 rounded-full" />
      
      <span
        aria-hidden="true"
        className={`${
          enabled ? 'translate-x-5' : 'translate-x-0'
        } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white/90 shadow-lg ring-0 transition duration-200 ease-in-out backdrop-blur-sm border border-white/30 relative z-10`}
      />
    </button>
  );
};

export default ToggleSwitch;
